import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  input,
  output,
  inject,
} from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { StyleClassModule } from 'primeng/styleclass';
import type { STAFFINTERFACE } from '@fitness-force/models';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  matchValidator,
  SpecialCharacterCheck,
  MinimumNumericalCheck,
  MinimumLowerCaseCheck,
  ConfirmedValidator,
  MinimumUpperCaseCheck,
} from '@fitness-force/shared-utils';
import { StaffService ,ToastMessageService} from '@fitness-force/api';
import { environment } from '@fitness-force/environments';
import { AppErrors } from '@fitness-force/models';
import { ErrorMsgComponent ,ErrorsComponent } from '@fitness-force/errors';
import { AsyncPipe } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { COMPANY_INFO } from '@fitness-force/state';


@Component({
  selector: 'staff-change-password',
  templateUrl: './staff-change-password.component.html',
  styleUrls: ['./staff-change-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    DialogModule,
    PasswordModule,
    ButtonModule,
    StyleClassModule,
    InputTextModule,
    ErrorMsgComponent,
    ErrorsComponent,
    TranslateModule,
    AsyncPipe,
  ],
})
export class StaffChangePasswordComponent implements OnInit {
  private readonly fb = inject(UntypedFormBuilder);
  private readonly staffService = inject(StaffService);
  private readonly translate = inject(TranslateService);
  private readonly store = inject(Store);
  private readonly toastMessageService = inject(ToastMessageService);

  readonly changePasswordModal = input<boolean>(false, { alias: 'visible' });
  readonly staff = input<STAFFINTERFACE>({} as STAFFINTERFACE);
  readonly isSelf = input<boolean>(false);
  readonly closePopup = output({ alias: 'closePopup' });
  readonly passwordChanged = output<{
    ischanged: boolean;
  }>({ alias: 'passwordChanged' });
  public companyInfoDetail$!: Observable<any>;

  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;
  error = new BehaviorSubject(null as AppErrors | null);
  HideErrorPopup(event: any) {
    this.showErrorPopup?.next(false);
    this.errorMessages = [];
    this.error.next(null);
  }

  formGroup: UntypedFormGroup;
  constructor() {
    this.formGroup = this.fb.group(
      {
        //old_password: new UntypedFormControl('', [Validators.required]),
        new_password: new UntypedFormControl('', [
          Validators.required,
          Validators.minLength(8),
          matchValidator('new_confirm_password', true),
          SpecialCharacterCheck('new_password', 1),
          MinimumNumericalCheck('new_password', 1),
          MinimumLowerCaseCheck('new_password', 1),
          MinimumUpperCaseCheck('new_password', 1),
        ]),
        new_confirm_password: new UntypedFormControl('', [Validators.required]),
      },
      {
        validator: [ConfirmedValidator('new_password', 'new_confirm_password')],
      },
    );
    this.formGroup.patchValue({ open_errorpoup: false });
  }

  // get OldPassword() {
  //   return this.formGroup.controls.old_password;
  // }

  get NewPassword() {
    return this.formGroup.controls.new_password;
  }

  get NewConfirmPassword() {
    return this.formGroup.controls.new_confirm_password;
  }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.store.select(COMPANY_INFO).subscribe((responseData) => {
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });
  }

  ValidateAndSubmit(): void {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      const staffId = this.staff().id;
      //let oldPassword = this.OldPassword.value;
      const newPassword = this.NewPassword.value;
      const service = this.isSelf() ? this.staffService.changeSelfPassword(newPassword) : this.staffService.ChangePassword(environment.BASE_URL, staffId, newPassword);
      service.subscribe({
        next: async () => {
            this.translate
              .get('STAFF.CHANGEPASSWORD.SUCCESS_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
            await this.timeout(1000);
            this.passwordChanged.emit({ ischanged: true });
            this.closePopup.emit();
            this.closePopup.emit();
          },
          error: (error: AppErrors) => {
            this.toastMessageService.showError(error);
          },
        });
    }
  }

  ClosePopup(): void {
    this.formGroup.reset();
    this.closePopup.emit();
    this.closePopup.emit();
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
